<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="editor mb-10">
                <quill-editor id="editor"
                  v-model="content" 
                  ref="myQuillEditor" 
                  :options="editorOption" 
                  @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)">
                </quill-editor>
            </div>
            <div class="ckeditor mb-10">
                <ckeditor :editor="editor" v-model="editorData"></ckeditor>
            </div>
            <div class="ckeditor mb-10">
                <ckeditor :editor="editor1" @ready="onReady" v-model="editorData1"></ckeditor>
            </div>
            <div class="ckeditor">
                <ckeditor :editor="editor2" @ready="onReady" v-model="editorData2" :config="editorConfig"></ckeditor>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import $ from 'jquery'
    import { quillEditor } from 'vue-quill-editor'
    import quillConfig from '../../assets/js-plug-in-unit/vue-quill-editor-config.js'
    import ckeditorConfig from './common-vue/vue-ckeditor-config'

    export default{
        data(){
            return {
                content:null,
                editorOption: quillConfig,

                editorData: '<p>Content of the editor.</p>',
                
                editorData1: '<p>Content of the editor.</p>',

                editorData2: '<p>Content of the editor.</p>',
            }
        },
        mixins:[ckeditorConfig],
        methods:{
            onEditorBlur(){//失去焦点事件  
            },
            onEditorFocus(){//获得焦点事件
            },
            onEditorChange(){//内容改变事件
            },
            elMinLeft(e, el){
                if($(e.target).hasClass(el) || $(e.target).parents().hasClass(el)){
                    if(parseInt($(".ql-tooltip.ql-editing").css('left')) < 0){
                        $(".ql-tooltip.ql-editing").css('left', 0)
                    }
                }
            },


            onReady( editor )  {
                // Insert the toolbar before the editable area.
                editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
            }
        },
        mounted(){
            this.content = `<blockquote><strong><em><s><u>qwe</u></s></em></strong></blockquote><pre class="ql-syntax" spellcheck="false">阿斯蒂</pre><blockquote><code><strong><em><s><u>阿萨德撒</u></s></em></strong></code></blockquote>`;
            this.$parent.main_header_active = false;
            let that = this;
            this.$nextTick(() => {
                $(document).click(function(e){
                    let arr = ["ql-link", 'ql-video', 'ql-formula'];
                    arr.map(list => {
                        that.elMinLeft(e, list);
                    })
                })
            });
            quillConfig.initButton();
            $(window).resize(function(){
                $(".ql-container").height($(".quill-editor").height() - $(".ql-toolbar.ql-snow").outerHeight(true));
            })
        },
        watch:{
            content(){
                // console.log(this.content)
            }
        },
        created(){
            this.$parent.routerLoading();
        },
    }
</script>
<style>
    .ql-container{
        height: calc(100% - 40px);
    }
</style>
<style scoped>
    #editor{
      height: 400px;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/editor.vue